import { styled, TextField } from '@mui/material';
const StyledTextField = styled(TextField)(({ theme }) => ({
    '& .MuiOutlinedInput-root': {
        borderRadius: theme.spacing(1.5),
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}30`,
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        '&:hover': {
            borderColor: theme.palette.primary.main,
            boxShadow: `0 0 0 2px ${theme.palette.primary.main}20`,
        },
        '&.Mui-focused': {
            borderColor: theme.palette.primary.main,
            boxShadow: `0 0 0 3px ${theme.palette.primary.main}20`,
        },
    },
    '& .MuiInputLabel-root': {
        fontWeight: 500,
        color: theme.palette.text.secondary,
    },
}));

const AppTextField = (props) => {
    return <StyledTextField {...props} />;
};

export default AppTextField;
